<template>
  <nav id="nav" ref="nav" class="main-nav">
    <ul class="makaList">
      <li>
        <router-link :to="putanja">{{ vinogradGl }}</router-link>
        <ul class="makaList">
          <template v-for="item in navVineYardItems">
            <template v-if="item">
              <li :key="item.id">
                <router-link
                  :key="$route.fullPath"
                  :to="{
                    name: 'single_vineyard',
                    params: { id: item.id, name_wine_type: item.name },
                  }"
                  >{{ item.name }}
                </router-link>
              </li>
            </template>
            <template v-else>
              <ul :key="item.id">
                <li>
                  <router-link to="/additive/">Nesto makarije</router-link>
                </li>
              </ul>
            </template>
          </template>
        </ul>
      </li>
      <li v-if="vinarija">
        <router-link to="/home">Podrum</router-link>
        <ul class="makaList">
          <template v-for="item in navItems">
            <template v-if="item.children">
              <li :key="item.id">
                <router-link
                  :key="$route.fullPath"
                  :to="{ name: 'tank_room', params: { id: item.menu.id } }"
                  >{{ item.menu.menuI18N[0].text }}
                </router-link>

                <ul>
                  <template v-for="childL1 in item.children">
                    <li :key="childL1.id">
                      <template v-if="childL1.tankPhaseWineId !== 0">
                        <router-link
                          :to="{
                            name: 'single_tank',
                            params: {
                              id: childL1.tankPhaseWineId,
                              idTank: childL1.id,
                            },
                          }"
                        >
                          {{ childL1.menuI18N[0].text }}
                        </router-link>
                      </template>
                      <template v-else>
                        <router-link
                          :to="{
                            name: 'empty_tank',
                            params: { id: childL1.id },
                          }"
                        >
                          {{ childL1.menuI18N[0].text }}
                        </router-link>
                      </template>
                    </li>
                  </template>
                </ul>
              </li>
            </template>
            <template v-else>
              <ul :key="item.id">
                <li>
                  <router-link to="/additive">Nesto ma</router-link>
                </li>
              </ul>
            </template>
          </template>
        </ul>
      </li>
      <li v-if="vinarija">
        <router-link to="/wine_types">Vina</router-link>
        <ul class="makaList">
          <template v-for="item in navWineItems">
            <template v-if="item.wineLabel">
              <li :key="item.id">
                <router-link
                  :key="$route.fullPath"
                  :to="{
                    name: 'wine_type',
                    params: {
                      id: item.id,
                      name_wine_type: item.name,
                      color_wine_type: item.description,
                    },
                  }"
                  >{{ item.name }}
                </router-link>

                <ul>
                  <template v-for="childL1 in item.wineLabel">
                    <li :key="childL1.id">
                      <router-link
                        :key="$route.fullPath"
                        :to="{ name: 'wine_year', params: { id: childL1.id } }"
                        >{{ childL1.name }}
                      </router-link>
                      <!-- <template v-if="childL1.id !== 0">
                        <router-link :to="{ name: 'vine', params: {id: childL1.id } }">{{childL1.name}}</router-link>
                      </template> -->
                      <!-- <template v-else>
                        <router-link :to="{ name: 'vine', params: {id: childL1.id } }">{{childL1.name}}</router-link>
                      </template> -->
                      <ul>
                        <template v-for="childL2 in childL1.wine">
                          <li :key="childL2.id">
                            <router-link
                              :to="{
                                name: 'single_wine',
                                params: { id: childL2.id },
                              }"
                            >
                              {{ childL2.year }}
                            </router-link>
                          </li>
                        </template>
                      </ul>
                    </li>
                  </template>
                </ul>
              </li>
            </template>
            <template v-else>
              <ul :key="item.id">
                <li>
                  <router-link to="/additive/">Nesto makarije</router-link>
                </li>
              </ul>
            </template>
          </template>
        </ul>
      </li>
      <!-- <li>
        <router-link
                            :to="{ name: 'ware_house_list', params: {id: 984, idTank: 15 } }">
                          Magacini
                        </router-link>
      </li> -->
      <li>
        <router-link to="/ware_houses"> Magacini </router-link>
        <ul class="makaList">
          <template v-for="item in navWareHouseItems">
            <template v-if="item.warehouseType">
              <template v-if="vinarija && item.warehouseType.enumLable === 'bottled_wine'">
                <li :key="item.warehouseType.id">
                  <router-link
                    :key="$route.fullPath"
                    :to="{
                      name: 'warehouse_type',
                      params: {
                        id: item.warehouseType.id,
                        warehouse_type_name: item.warehouseType.name,
                      },
                    }"
                    >{{ item.warehouseType.name }}
                  </router-link>

                  <ul class="makaList">
                    <template v-for="childL1 in item.warehouse">
                      <li :key="childL1.id">
                        <router-link
                          :key="$route.fullPath"
                          :to="{
                            name: 'ware_house_list',
                            params: {
                              id: childL1.id,
                              name: childL1.name,
                              type: childL1.warehouseType.enumLable,
                            },
                          }"
                          >{{ childL1.name }}
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </li>
              </template>
              <template v-else-if="item.warehouseType.enumLable !== 'bottled_wine'">
                <li :key="item.warehouseType.id">
                  <router-link
                    :key="$route.fullPath"
                    :to="{
                      name: 'warehouse_type',
                      params: {
                        id: item.warehouseType.id,
                        warehouse_type_name: item.warehouseType.name,
                      },
                    }"
                    >{{ item.warehouseType.name }}
                  </router-link>

                  <ul class="makaList">
                    <template v-for="childL1 in item.warehouse">
                      <li :key="childL1.id">
                        <router-link
                          :key="$route.fullPath"
                          :to="{
                            name: 'ware_house_list',
                            params: {
                              id: childL1.id,
                              name: childL1.name,
                              type: childL1.warehouseType.enumLable,
                            },
                          }"
                          >{{ childL1.name }}
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </li>
              </template>
            </template>
            <template v-else>
              <ul :key="item.id">
                <li>
                  <router-link to="/additive/">Nesto makarije</router-link>
                </li>
              </ul>
            </template>
          </template>
        </ul>
      </li>
      <li>
        <router-link :to="vinarija ? '/catalog_info' : '/catalog_info_other'">Katalozi</router-link>
        <ul class="makaList">
          <li>
            <router-link to="/additive">Aditivi</router-link>
          </li>
          <li>
            <router-link to="/additive_group">Grupe aditiva</router-link>
          </li>
          <li>
            <router-link to="/currency">Valute</router-link>
          </li>
          <li>
            <router-link to="/grape_variety">Sorte</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/phase">Faze</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/room_sif">Prostorije</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/tank_sif">Tankovi</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/tank_type">Tipovi tankova</router-link>
          </li>
          <li>
            <router-link to="/unit_of_measure">Jedinice mere</router-link>
          </li>
          <li>
            <router-link to="/unit_of_measure_group"
              >Grupe jedinica mere</router-link
            >
          </li>
          <li>
            <router-link to="/vine_yard">{{ vinogradGl1 }}</router-link>
          </li>
          <li>
            <router-link to="/vine_yard_block">{{ vinogradGl2 }}</router-link>
          </li>
          <li>
            <router-link to="/vine_yard_table">{{ vinogradGl3 }}</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/wine_types_all">Tipovi vina</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/wine_label">Etikete</router-link>
          </li>
          <li v-if="vinarija">
            <router-link to="/wine">Vina</router-link>
          </li>
          <li>
            <router-link to="/vineyard_grape">{{ vinogradGl5 }}</router-link>
          </li>
          <li>
            <router-link to="/parameter">Parametri</router-link>
          </li>
          <li>
            <router-link to="/ware_house">Magacini</router-link>
          </li>
          <li>
            <router-link to="/warehause_type">Tipovi magacina</router-link>
          </li>
          <li>
            <router-link to="/employee">Zaposleni</router-link>
          </li>
          <li>
            <router-link to="/externalWorkForce">Eksterni radnici</router-link>
          </li>
          <li>
            <router-link to="/company">Partneri</router-link>
          </li>
          <li>
            <router-link to="/mehanization">Mehanizacija</router-link>
          </li>
          <li>
            <router-link to="/vineyard_operation"
              >{{ vinogradGl4 }}</router-link
            >
          </li>
          <li>
            <router-link to="/winery">Matični podaci</router-link>
          </li>
          <li>
            <router-link to="/phenophase">Feno faza</router-link>
          </li>
          <li>
            <router-link to="/pruningtype">Tip rezidbe</router-link>
          </li>
          <li>
            <router-link to="/breedingtype">Uzgojni oblik</router-link>
          </li>
        </ul>
      </li>
      <!-- <li>
        <router-link to="">Ostalo</router-link>
        <ul>
          <li>
            <router-link to="/additive">Example</router-link>
            <ul>
              <li>
                <router-link to="/additive">Sublink 1</router-link>
                <ul>
                  <li>
                    <router-link to="/additive">Sublink 1.1</router-link>
                  </li>
                  <li>
                    <router-link to="/additive">Sublink 2.2</router-link>
                  </li>
                  <li>
                    <router-link to="/additive">Sublink 3.3</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <router-link to="/modal_primer">Modal u modalu</router-link>
          </li>
        </ul>
      </li> -->
    </ul>
  </nav>
</template>

<script>
import jQuery from "jquery";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";

global.jQuery = jQuery;
let mmenu = require("jquery.mmenu");
require("jquery.mmenu/dist/addons/counters/jquery.mmenu.counters");
//Icon bar
require("jquery.mmenu/dist/addons/iconbar/jquery.mmenu.iconbar");
require("jquery.mmenu/dist/addons/iconbar/jquery.mmenu.iconbar.css");

//All
require("jquery.mmenu/dist/jquery.mmenu.all.css");

export default {
  name: "Navigation",
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    navWineItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    navWareHouseItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    navVineYardItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      vinarija: true,
      vinogradGl: "Vinograd",
      vinogradGl1: "Vinogradi",
      vinogradGl2: "Parcele u vinogradu",
      vinogradGl3: "Table u vinogradu",
      vinogradGl4: "Operacije u vinogradu",
      vinogradGl5: "Sorte u vinogradu",
      putanja: "/vineyards",
    };
  },
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));
    this.vinogradGl = "Vinograd";

    if (this.vinarija) {
      this.putanja = "/vineyards";
    } else {
      this.putanja = "/";
      this.vinogradGl = "Zasad";
      this.vinogradGl1 = "Zasadi";
      this.vinogradGl2 = "Parcele u zasadu";
      this.vinogradGl3 = "Table u zasadu";
      this.vinogradGl4 = "Operacije u zasadu";
      this.vinogradGl5 = "Sorte u zasadu";
    }
  },
  mounted: function () {
    jQuery(this.$el).mmenu({
      offCanvas: false,
      extensions: ["theme-dark"],
      counters: true,
      navbar: {
        title: "Meni",
      },
    });
    let menu = jQuery("#nav");
    let menuData = menu.data("mmenu");

    // jQuery('<p class="siteTitle">' + this.globalViarija + '</p>').insertBefore(
    // 	"#nav > .mm-panels .mm-panel .mm-navbar__title"
    // );

    // jQuery('<p class="siteTitle">Wine App</p>').insertBefore(
    // 	"#nav > .mm-panels .mm-panel .mm-navbar__title"
    // );
    jQuery(".mm-iconbar").click(() => {
      menuData.openPanel(jQuery(".mm-panel:first-child"));
    });

    menu.find('a:not(".mm-btn_next"):not(".mm-btn")').click(() => {
      menu.removeClass("open");
      jQuery("#navIcon").removeClass("open");
    });
  },
};
</script>

<style lang="scss">
ul.makaList li:hover {
  transform: scale(1.3);
  transition: all 0.4s ease-in-out;
}
</style>